// @flow

import Route from 'PMT/flux/Route';

import LoginPage from '../pages/login/LoginPage';
import ForgotPasswordPage from '../pages/forgotPassword';
import LogoutPage from '../pages/logout/LogoutPage';
import StatPage from '../pages/payment/stat/StatPage';
import ReceiptPage from '../pages/payment/receipt/ReceiptPage';
import OrdersListPage from '../pages/order/ordersList/OrdersListPage';
import PromotionsList from '../pages/order/cartModifiers/list/index';
import PromotionsEdit from '../pages/order/cartModifiers/edit/index';
import OrderSettingsPage from '../pages/order/settings/OrderSettingsPage';
import OrderStatisticsPage from '../pages/order/statistics/index';
import RestaurantMenuPage from '../pages/menu/RestaurantMenuPage';
import EditRestaurantPage from '../pages/restaurant/edit/EditRestaurantPage';
import NotFoundPage from '../pages/other/NotFoundPage';
import MenuDetailPage from '../pages/menu/menu/MenuDetailPage';
import MenuEditPage from '../pages/menu/menuEdit/MenuEditPage';
import ProductEditPage from '../pages/menu/productEdit/ProductEditPage';
import ProductCategoryDetailPage from '../pages/menu/category/ProductCategoryDetailPage';
import MenuPartEditPage from '../pages/menu/menuPartEdit/MenuPartEditPage';
import UpsellingCategoryDetailPage from '../pages/menu/upsellingCategories/detail/UpsellingCategoryDetailPage';
import ProductOptionDetailPage from '../pages/menu/option/ProductOptionDetailPage';
import ProductOptionEditPage from '../pages/menu/optionEdit/ProductOptionEditPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import FeatureNonActivatedPage from '../pages/other/FeatureNonActivatedPage';
import ServerErrorPage from '../pages/other/ServerErrorPage';
import CGUPage from '../pages/other/CGUPage';
import RestaurantsGroup from '../pages/proAccounts/restaurantsGroup/RestaurantsGroup';
import RedirectPage from '../pages/other/RedirectPage';

/**
 * Define all the app routes.
 */
class RoutingEnum {
  static DASHBOARD = new Route('dashboard', '/', DashboardPage);

  static STAT_HOME = new Route('stat', '/statistics', StatPage);

  static LOGIN = new Route('login', '/login', LoginPage, false);

  static FORGOT_PASSWORD = new Route('forgotPassword', '/forgot-password', ForgotPasswordPage, false);

  static LOGOUT = new Route('logout', '/logout', LogoutPage);

  static RECEIPT = new Route('receipts', '/receipts', ReceiptPage);

  static ORDERS_LIST = new Route('order_list', '/orders', OrdersListPage);

  //
  // Menu
  //

  static RESTAURANT_MENU = new Route(
    'RESTAURANT_MENU',
    '/restaurant-menu',
    RestaurantMenuPage
  );

  //
  // Menu - menu
  //

  static RESTAURANT_MENU_MENU_NEW = new Route(
    'RESTAURANT_MENU_MENU_NEW',
    '/restaurant-menu/menus/new',
    MenuEditPage
  );

  static RESTAURANT_MENU_MENU_DETAIL = new Route(
    'RESTAURANT_MENU_MENU_DETAIL',
    '/restaurant-menu/menus/:menuId',
    MenuDetailPage
  );

  static RESTAURANT_MENU_MENU_EDIT = new Route(
    'RESTAURANT_MENU_MENU_EDIT',
    '/restaurant-menu/menus/:menuId/edit',
    MenuEditPage
  );

  //
  // Menu - part
  //
  static RESTAURANT_MENU_PART_EDIT = new Route(
    'RESTAURANT_MENU_PART_EDIT',
    '/restaurant-menu/menus/:menuId/parts/:menuPartId/edit',
    MenuPartEditPage
  );

  //
  // Menu - product
  //

  static RESTAURANT_MENU_PRODUCT_NEW = new Route(
    'RESTAURANT_MENU_PRODUCT_NEW',
    '/restaurant-menu/products/new',
    ProductEditPage
  );

  static RESTAURANT_MENU_PRODUCT_EDIT = new Route(
    'RESTAURANT_MENU_PRODUCT_EDIT',
    '/restaurant-menu/products/:productId/edit',
    ProductEditPage
  );

  //
  // Menu - productOption
  //

  static RESTAURANT_MENU_PRODUCT_OPTION_NEW = new Route(
    'RESTAURANT_MENU_OPTION_NEW',
    '/restaurant-menu/options/new',
    ProductOptionEditPage
  );

  static RESTAURANT_MENU_PRODUCT_OPTION_DETAIL = new Route(
    'RESTAURANT_MENU_OPTION_DETAIL',
    '/restaurant-menu/options/:productOptionId',
    ProductOptionDetailPage
  );

  static RESTAURANT_MENU_PRODUCT_OPTION_EDIT = new Route(
    'RESTAURANT_MENU_OPTION_EDIT',
    '/restaurant-menu/options/:productOptionId/edit',
    ProductOptionEditPage
  );

  //
  //
  //

  static RESTAURANT_MENU_CATEGORY_DETAIL = new Route(
    'RESTAURANT_MENU_CATEGORY_DETAIL',
    '/restaurant-menu/categories/:categoryId',
    ProductCategoryDetailPage
  );

  //
  //
  //

  static RESTAURANT_MENU_UPSELLING_CATEGORY_DETAIL = new Route(
    'RESTAURANT_MENU_CATEGORY_DETAIL',
    '/restaurant-menu/upselling-categories/:upsellingCategoryId',
    UpsellingCategoryDetailPage
  );

  /**
   * Promotions
   */
  static ORDERS_CART_MODIFIERS_LIST = new Route(
    'order_cart_modifiers_list',
    '/orders/cart-modifiers',
    PromotionsList
  );
  static ORDERS_CART_MODIFIERS_NEW = new Route(
    'order_cart_modifiers_new',
    '/orders/cart-modifiers/new',
    PromotionsEdit
  );
  static ORDERS_CART_MODIFIERS_EDIT = new Route(
    'order_cart_modifiers_edit',
    '/orders/cart-modifiers/:cartModifierId/edit',
    PromotionsEdit
  );

  //
  //
  //

  static ORDER_STATISTICS = new Route(
    'ORDER_STATISTICS',
    '/orders/statistics',
    OrderStatisticsPage
  );

  static ORDER_SETTINGS = new Route(
    'order_settings',
    '/orders/settings',
    OrderSettingsPage
  );

  static RESTAURANT_EDIT = new Route(
    'restaurant_edit',
    '/account',
    EditRestaurantPage
  );

  static FEATURE_NON_ACTIVATED = new Route(
    'feature_no_activated',
    '/feature-non-activated',
    FeatureNonActivatedPage
  );

  //
  // RestaurantsGroup
  //
  static RESTAURANTS_GROUP = new Route(
    'restaurants_group',
    '/restaurants-group',
    RestaurantsGroup
  );

  //
  // Other
  //

  static REDIRECT_PAGE = new Route('redirect', '/redirect', RedirectPage);

  static SERVER_ERROR = new Route(
    'server_error',
    '/server-error',
    ServerErrorPage
  );

  // -- disabled
  static CGU = new Route('cgu', '/cgu', CGUPage, false);

  static NOT_FOUND = new Route('not_found', '*', NotFoundPage, false);
}

export default RoutingEnum;



// WEBPACK FOOTER //
// ./scripts/constants/RoutingEnum.js